import { MemberTypeEnum } from "./permissionsmodel";

export type WebPush = {
  endpoint: string;
  expirationTime: number;
  keys: {
    p256dh: string;
    auth: string;
  };
};

export enum AcceptanceTypesEnum {
  AcceptTaC = 'AcceptTaC',
  AcceptPP = 'AcceptPP',
  WithdrawTaC = 'WithdrawTaC',
  WithdrawPP = 'WithdrawPP',
}

export interface IUser {
  providerUserUUID: string;
  userUUID: string;
  firstName: string;
  lastName: string;
  email: string;
  idProvider?: string;
  phone?: string;
  img?: string;
  webPush?: WebPush[];
  memberType: MemberTypeEnum;
  subscriptionType?: string;
  subscriptionStartDate?: string;
  subscriptionEndDate?: string;
  lastLogin?: string;
}

export class User implements IUser {
  providerUserUUID: string;
  userUUID: string;
  firstName: string;
  lastName: string;
  email: string;
  idProvider?: string;
  phone?: string;
  img?: string;
  webPush?: WebPush[];
  memberType: MemberTypeEnum;
  subscriptionType?: string;
  subscriptionStartDate?: string;
  subscriptionEndDate?: string;
  lastLogin?: string;

  constructor(data: IUser) {
    this.providerUserUUID = data.providerUserUUID;
    this.userUUID = data.userUUID;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.email = data.email;
    this.idProvider = data.idProvider;
    this.phone = data.phone;
    this.img = data.img;
    this.webPush = data.webPush;
    this.memberType = data.memberType;
    this.subscriptionType = data.subscriptionType;
    this.subscriptionStartDate = data.subscriptionStartDate;
    this.subscriptionEndDate = data.subscriptionEndDate;
    this.lastLogin = data.lastLogin;
  }
}

